import React, { useEffect, useState } from "react";
import { TablePagination } from "@mui/material";
import TableHeader from "../table/TableHeader";
import MainTableBody from "../table/MainTableBody";
import JourneyConfigTableRow from "./JourneyConfigTableRow";
import CustomTable from "../table/CustomTable";
import { LoadingTableSkeleton } from "../../utils/common";
import NoDataTable from "../table/NoDataTable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import FilterDropdown from "../filter/FilterDropdown";
import Cookies from "js-cookie";

export const CreateTemplate = () => {
  return (
    <div className="">
      <Link to={"/dashboard/templates/create"}>
        <button className=" bg-purple-300 flex items-center py-2 pl-2 pr-3 text-white font-bold rounded">
          <Add fontSize="small" className="ml-0 pl-0 " />
          Create
        </button>
      </Link>
    </div>
  );
};

export default function JourneyConfigTable({
  reqState,
  object,
  setObject,
  handleFetch,
  handleFetchWithPage,
}) {
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [page, setPage] = React.useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (reqState.response?.pageInfo) {
      setRowsPerPage(reqState.response.pageInfo.perPage);
      setPage(reqState.response.pageInfo.currentPage - 1); // Convert to 0-indexed for MUI
    }
  }, [reqState?.response]);

  const updateQueryParams = (updatedParams) => {
    const searchParams = new URLSearchParams(location.search);

    // Update or remove query parameters based on `updatedParams`
    Object.keys(updatedParams).forEach((key) => {
      if (updatedParams[key] !== undefined && updatedParams[key] !== null) {
        searchParams.set(key, updatedParams[key]);
      } else {
        searchParams.delete(key);
      }
    });

    // Navigate with updated query parameters
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const { isLoading, response } = reqState;

  const refetch = () => {
    handleFetch();
  };

  const columns = [
    "Config Id",
    "Template Name",
    "Product Type",
    "Product Code",
    "Text on Policy Page",
    "Language",
    "Script readout on Personal details Page",
    "Script readout on Policy Page",
    "Script on Video Consent Page",
    "Time For Video Consent in Seconds",
    "Text Match Percentage",
    "Actions",
  ];

  useEffect(() => {
    if (response?.pageInfo) {
      setRowsPerPage(response?.pageInfo.perPage);
      setPage(response?.pageInfo?.currentPage - 1);
    }
  }, [response]);

  const handleChangePage = (event, newPage) => {
    const updatedPage = newPage + 1; // Material-UI uses 0-based indexing
    updateQueryParams({ page: updatedPage });
    handleFetchWithPage(updatedPage); // Trigger fetch for the new page
  };

  const handleRowsPerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to the first page
    updateQueryParams({ perPage: newPerPage, page: 1 });
  };

  return (
    <>
      <div
        className="py-1 px-4"
        style={{
          height: `calc(100vh - 100px)`,
        }}
      >
        <div className="flex flex-row mb-4 items-center justify-between">
          <p className="text-xl mb-0 font-extrabold">
            Templates ({response?.pageInfo.total})
          </p>
          <div className="flex flex-row">
            <FilterDropdown object={object} setObject={setObject} />
            <button
              onClick={() => refetch()}
              className="border focus:border-blue-600 flex items-center border-[#E0E0E0] mx-2 rounded py-1.5 px-3"
            >
              Refresh Data
            </button>
            {JSON.parse(Cookies.get("userDets")).role === "ADMIN" && (
              <CreateTemplate />
            )}
          </div>
        </div>

        {!response?.data && !isLoading ? (
          <NoDataTable
            columns={columns}
            recordingKeyClassName={true}
            message={"Server Error, Please try again later."}
          />
        ) : response?.data?.length === 0 && !isLoading ? (
          <NoDataTable
            columns={columns}
            recordingKeyClassName={true}
            message={
              "No templates available. Create a template to see it here."
            }
          />
        ) : (
          <CustomTable>
            <TableHeader columns={columns} />
            <MainTableBody isLoading={isLoading}>
              {response?.data.length === 0
                ? [1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                    <LoadingTableSkeleton key={i} index={i} />
                  ))
                : response?.data.map((row, i) => (
                    <JourneyConfigTableRow
                      key={i}
                      row={row}
                      refetch={refetch}
                    />
                  ))}
            </MainTableBody>

            {response?.pageInfo && (
              <TablePagination
                className="sticky bottom-0 bg-white"
                rowsPerPageOptions={[2]}
                count={response?.pageInfo.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onRowsPerPageChange={handleRowsPerPageChange}
                onPageChange={handleChangePage}
              />
            )}
          </CustomTable>
        )}
      </div>
    </>
  );
}
